import { render, staticRenderFns } from "./KLAJP.vue?vue&type=template&id=2eeecfbe&scoped=true"
import script from "./KLAJP.vue?vue&type=script&lang=js"
export * from "./KLAJP.vue?vue&type=script&lang=js"
import style0 from "./KLAJP.vue?vue&type=style&index=0&id=2eeecfbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eeecfbe",
  null
  
)

export default component.exports